<template>
  <div class="progress-box-pkg">
    <div class="progress-mask" v-if="progressInfo.firstExtract" />
    <div class="progress-content" ref="dialogEl" :style="{ left: left + 'px', top: top + 'px' }">
      <div class="first-extract" v-if="progressInfo.firstExtract">
        <div class="first-extract-close" @click="closeProgress" />
        <div class="first-extract-content">
          <div class="progress-txt">
            <div class="main-txt">{{ $t('正在从压缩包中提取文件，请稍等') }}</div>
            <div class="minor-txt">{{ $t('时间根据压缩包大小不等') }}</div>
          </div>
        </div>
      </div>
      <div class="top-progress" v-else>
        <div class="top-progress-content">
          <span>{{ progressInfo.txt }}</span>
          <span>{{ `${progress}%` }}</span>
        </div>
      </div>
      <el-progress :percentage="progress" :show-text="false" color="#0A64FA" />
    </div>
  </div>
</template>

<script>
import { getWidthOrHeight } from 'js/util/util'

export default {
  props: {
    progressData: Object,
  },
  data() {
    return {
      left: 0,
      top: 20,
      progress: 10,
      isSlow: false, // 是否让进度条慢下来
      timer: null,
    }
  },
  computed: {
    progressInfo() {
      return this.progressData
    },
  },
  methods: {
    setPos() {
      const $dialog = this.$refs.dialogEl
      const elemH = getWidthOrHeight($dialog, 'height')
      const elemW = getWidthOrHeight($dialog, 'width')
      const winH = window.innerHeight || document.documentElement.clientHeight
      const winW = window.innerWidth || document.documentElement.clientWidth
      this.left = (winW - elemW) / 2
      if (this.progressData.firstExtract) {
        this.top = (winH - elemH) / 2
      }
    },
    startProgress() {
      if (this.timer == null) {
        this.timer = setInterval(this.loading, 100)
      }
    },
    loading() {
      if (this.progress === 99) {
        clearInterval(this.timer)
        this.timer = null
        return
      }
      if (this.progress >= 80) {
        this.progress += 1
        if (!this.isSlow) {
          clearInterval(this.timer)
          this.timer = setInterval(this.loading, 1000)
          this.isSlow = true
        }
      } else {
        this.progress += 1
      }
    },
    closeProgress() {
      this.$emit('closeProgress')
    },
  },
  mounted() {
    this.setPos()
    clearInterval(this.timer)
    this.timer = null
    this.startProgress()
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
  },
}
</script>

<style lang="less" scoped>
.progress-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
  width: 100%;
  height: 100%;
}
.progress-content {
  position: fixed;
  z-index: 999;
  box-sizing: border-box;
  width: 350px;
  min-height: 20px;
  padding: 20px;
  font-size: 15px;
  font-size: 14px;
  text-align: center;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  .first-extract {
    z-index: 100;
    .first-extract-close {
      position: absolute;
      top: 21px;
      right: 24px;
      width: 20px;
      height: 20px;
      cursor: pointer;
      background-image: url(~image/close.svg);
      background-repeat: no-repeat;
      background-position: right;
    }
    .first-extract-content {
      .main-txt {
        font-size: 16px;
        color: #282e3d;
      }
      .minor-txt {
        margin-top: 5px;
        margin-bottom: 10px;
        color: #929ca9;
      }
    }
  }
  .top-progress {
    .top-progress-content {
      margin-bottom: 10px;
      color: #4d5365;
    }
  }
}
</style>
